var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLupe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_335_10462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9508 26.0001L22.9501 25.9993L14.3334 16.2306L14.2703 15.2235C12.6935 16.5712 10.6851 17.3131 8.61674 17.3133C6.32127 17.3134 4.16245 16.4192 2.53795 14.7951C-0.84045 11.4158 -0.84045 5.9173 2.53795 2.538C4.17504 0.90135 6.35153 0 8.6665 0C10.9815 0 13.158 0.90135 14.795 2.538C16.3449 4.08786 17.2376 6.14657 17.3088 8.3349C17.3793 10.5065 16.6391 12.6141 15.2243 14.2695L16.2315 14.3325L26.0001 22.9509L22.9516 25.9994L22.9508 26.0001ZM8.6665 1.4481C6.73516 1.4481 4.92144 2.19794 3.55945 3.5595C0.74432 6.37554 0.74432 10.9576 3.55945 13.7736C4.92144 15.1356 6.73516 15.8857 8.6665 15.8857C10.5978 15.8857 12.4116 15.1356 13.7736 13.7736C16.5896 10.9576 16.5896 6.37554 13.7736 3.5595C12.4116 2.19794 10.5978 1.4481 8.6665 1.4481Z",
    fill: "#084524"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_335_10462",
    x: -9.99585,
    y: -10,
    width: 45.9958,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_335_10462"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_335_10462",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupe);
export default __webpack_public_path__ + "static/media/lupe.eabdf66b60ec4782524140c92a511ea0.svg";
export { ForwardRef as ReactComponent };